var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('BaseMessage',{directives:[{name:"show",rawName:"v-show",value:(_vm.messages.length > 0),expression:"messages.length > 0"}],staticClass:"mb_15 mt_10",attrs:{"design":'red',"messages":_vm.messages}}),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }